import React from 'react';
import { AlertTriangle, ArrowRight, CheckCircle2 } from 'lucide-react';

interface QuickFixBannerProps {
  incompleteCount: number;
  totalCount: number;
  isFilterActive: boolean;
  onToggleFilter: () => void;
  onOpenQuickFix: () => void;
}

export const QuickFixBanner: React.FC<QuickFixBannerProps> = ({
  incompleteCount,
  totalCount,
  isFilterActive,
  onToggleFilter,
  onOpenQuickFix,
}) => {
  if (totalCount === 0) return null;

  if (incompleteCount === 0) {
    return (
      <div className="mb-4 p-3.5 rounded-xl bg-emerald-50 dark:bg-emerald-950/30 border border-emerald-200 dark:border-emerald-800/50 flex items-center justify-between text-xs text-emerald-900 dark:text-emerald-200 shadow-xs">
        <div className="flex items-center gap-2">
          <CheckCircle2 className="w-4 h-4 text-emerald-600 dark:text-emerald-400 shrink-0" />
          <span><strong className="font-bold text-emerald-950 dark:text-emerald-100">Minden kötelező adat rögzítve!</strong> A közzétételi oldal megfelel a jogszabályi előírásoknak.</span>
        </div>
      </div>
    );
  }

  return (
    <div className="mb-4 p-3.5 rounded-xl bg-amber-50/90 dark:bg-amber-950/40 border-2 border-amber-300 dark:border-amber-700/60 flex flex-wrap items-center justify-between gap-3 text-xs text-amber-950 dark:text-amber-100 shadow-xs">
      <div className="flex items-center gap-2.5">
        <AlertTriangle className="w-4 h-4 text-amber-600 dark:text-amber-400 shrink-0 animate-pulse" />
        <div>
          <span className="font-bold text-amber-950 dark:text-amber-100">{incompleteCount} kötelező tétel hiányos vagy mellékletre vár!</span>
          <span className="hidden sm:inline text-amber-800 dark:text-amber-300/80 font-medium ml-1.5">(A 2011. évi CXII. tv. szerinti közzétételhez pótlás szükséges)</span>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={onToggleFilter}
          className={`px-3 py-1.5 rounded-lg border text-xs font-semibold transition cursor-pointer ${
            isFilterActive
              ? 'bg-amber-600 text-white border-amber-700 font-bold'
              : 'bg-amber-100 dark:bg-amber-500/20 text-amber-900 dark:text-amber-200 border-amber-300 dark:border-amber-600/40 hover:bg-amber-200 dark:hover:bg-amber-500/30'
          }`}
        >
          {isFilterActive ? '✕ Szűrő kikapcsolása' : 'Csak a hiányosak szűrése'}
        </button>

        <button
          onClick={onOpenQuickFix}
          className="px-3.5 py-1.5 rounded-lg bg-amber-500 hover:bg-amber-600 active:bg-amber-700 text-white font-bold text-xs shadow-sm flex items-center gap-1.5 transition cursor-pointer"
        >
          <span>Gyorspótlás</span>
          <ArrowRight className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};
